import {
  Image as ExpoImage,
  type ImageProps as ExpoImageProps,
  type ImageContentFit,
  type ImageStyle,
} from "expo-image";
import type React from "react";
import { memo } from "react";
import { type ImageSourcePropType, type StyleProp, StyleSheet, type ViewStyle } from "react-native";

import Block from "./Block";

export type ImageProps = {
  source: ImageSourcePropType | string;
  width?: number | string;
  height?: number | string;
  style?: StyleProp<ViewStyle>;
} & Omit<ExpoImageProps, "style">;

// Omit the width and height props for mobile
export const Image = memo(({ width, height, style = {}, source, ...restProps }: ImageProps) => {
  return (
    <ExpoImage source={source} style={[{ width, height }, style] as ImageStyle} {...restProps} />
  );
});

type ImageBackgroundProps = {
  width?: number | string;
  height?: number | string;
  style?: StyleProp<ViewStyle>;
  imageStyle?: ImageStyle;
  contentContainerStyle?: StyleProp<ViewStyle>;
  source: ImageSourcePropType | string;
  children: React.ReactNode;
  contentFit?: ImageContentFit;
} & Omit<ExpoImageProps, "style">;

export const ImageBackground = memo(
  ({
    style = {},
    imageStyle = {},
    children,
    contentContainerStyle,
    ...restProps
  }: ImageBackgroundProps) => {
    const { width, height } = StyleSheet.flatten(style);

    return (
      <Block style={[{ height }, style]}>
        <ExpoImage {...restProps} style={[styles.image, { width, height }, imageStyle]} />

        <Block style={[styles.content, contentContainerStyle]}>{children}</Block>
      </Block>
    );
  },
);

const styles = StyleSheet.create({
  content: {
    bottom: 0,
    flex: 1,
    left: 0,
    position: "absolute",
    right: 0,
    top: 0,
  },
  image: {
    flex: 1,
  },
});
